import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
import AnimatedMenu from '../prefabs/AnimatedMenu.js';
import ItemMenu from '../prefabs/ItemMenu.js';
import ItemMenuRenfo from '../prefabs/ItemMenuRenfo.js';
import { MenuData } from '../consts/Data.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { tags } from '../consts/Tags.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: "Menu"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.itemData = MenuData;
        this.allItems = []
        this.selectedActivity = null;
        this.selectedItem = null
        this.level = this.game.data.level
        this.partieLevel = this.level < 4 ? 0 : 1;
    }

    create() {
        this.soundManager(1870, 960)
        this.addBackgroundMusique('minimal')
        this.menu = new AnimatedMenu(this, this.level)


        let txt = ""
        this.activiteTitle = this.add.rexTagText(107, 390, txt, {
            fontSize: "60px",
            fontFamily: "CenturyGothicBold",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 800 }
        }).setAlpha(0)
        let content = ""
        let contentY = this.activiteTitle.y + this.activiteTitle.height + 20;
        this.activiteContent = this.add.rexTagText(107, contentY, content, {
            fontSize: "30px",
            fontFamily: "CenturyGothic",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 750 }
        }).setAlpha(0)
        this.createItems(this.partieLevel);

        this.allItems.forEach(item => { item.setAlpha(0) })


        this.startBtn = new ButtonImageSliced(this, 465, 760, 320, 80, "bouton", "Commencer").setAlpha(0)
        this.startBtn.setClickFunction(() => { this.menuOut() })

        this.menu.menuIn()
        if (this.level === 7) {

        }

    }
    soundCut() {
        if (this.backgroundMusic) {
            this.backgroundMusic.stop();
        }
    }

    setItemsStatus() {
        let localLevel = this.game.data.level - 1;

        // Détermine si on est en Partie A (0-3) ou Partie B (4-6)
        let currentPartie = this.game.data.level < 4 ? 0 : 1;

        if (this.game.data.level === 1 || this.game.data.level === 4) {
            this.startBtn.setTextContent("Lancer")
        } else {
            this.startBtn.setTextContent("Continuer")
        }
        this.allItems.forEach((item, id) => {
            console.log('id, localLevel', id, localLevel);
            this.tweens.add({
                targets: item,
                alpha: 1,
                duration: 500,
                ease: 'Power2',
                delay: id * 100,
                onComplete: () => {
                    if (id === 2) {
                        if (this.game.data.level === 7) {
                            this.allItems.forEach(card => {
                                card.setOpen();
                            });
                            this.activiteContent.setText(this.itemData[6].content);
                            this.activiteTitle.setText(this.itemData[6].title);
                            this.card7.setActive()

                            // this.allItems[2].setActive();

                        } else {
                            // Calcul du niveau local selon la partie
                            localLevel = currentPartie === 0 ? (this.game.data.level - 1) : (this.game.data.level - 4);
                            console.log('localLevel', localLevel, 'currentPartie', currentPartie);
                            this.allItems.forEach((card, idx) => {
                                if (idx < localLevel) {
                                    card.setOpen();
                                } else if (idx === localLevel) {
                                    card.setActive();
                                } else {
                                    card.setLocked();
                                }
                            });
                        }
                    }
                }
            })
        })

    }

    menuOut() {
        this.startBtn.setAlpha(0)
        this.tweens.add({
            targets: [this.activiteTitle, this.activiteContent],
            alpha: 0,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.allItems.forEach((item, id) => {
                    this.tweens.add({
                        targets: item,
                        alpha: 0,
                        duration: 300,
                        ease: 'Power2',
                        delay: id * 300,
                        onComplete: () => {
                            if (id === this.allItems.length - 1) {
                                this.menu.menuOut(this.selectedActivity)
                            }
                        }
                    })
                })

            }
        })
    }

    createItems(partieLevel) {
        if (partieLevel === 0) {
            this.card1 = new ItemMenu(this, this.itemData[0].cardX, this.itemData[0].cardY, this.itemData[0])
            this.allItems.push(this.card1)
            this.card2 = new ItemMenu(this, this.itemData[1].cardX, this.itemData[1].cardY, this.itemData[1])
            this.allItems.push(this.card2)
            this.card3 = new ItemMenu(this, this.itemData[2].cardX, this.itemData[2].cardY, this.itemData[2])
            this.allItems.push(this.card3)
        } else {
            this.card4 = new ItemMenu(this, this.itemData[3].cardX, this.itemData[3].cardY, this.itemData[3])
            this.allItems.push(this.card4)
            this.card5 = new ItemMenu(this, this.itemData[4].cardX, this.itemData[4].cardY, this.itemData[4])
            this.allItems.push(this.card5)
            this.card6 = new ItemMenu(this, this.itemData[5].cardX, this.itemData[5].cardY, this.itemData[5])
            this.allItems.push(this.card6)
            if (this.game.data.level === 7) {
                this.card7 = new ItemMenuRenfo(this, this.itemData[6].cardX, this.itemData[6].cardY, this.itemData[6])
                this.allItems.push(this.card7)
            }
        }
    }

    addConclusionBtn() {
        this.clickSound = this.sound.add('click', { volume: 0.4 });
        this.conclusionBtn = this.add.container(1599, 285);
        this.rect = this.add.rexRoundRectangle(0, 0, 390, 155, 15, Colors.Elmt.lightBlue).setOrigin(0);
        this.conclusionBtn.add(this.rect);

        this.strocks = this.add.rexRoundRectangle(-10, -10, 390, 155, 15, Colors.Elmt.lightBlue, 0).setOrigin(0);
        this.strocks.setStrokeStyle(3, Colors.Elmt.Black)
        this.conclusionBtn.add(this.strocks);


        this.txt = this.add.rexTagText(390 / 2, 155 / 2, "Conclusion", {
            fontSize: "40px",
            fontFamily: "CenturyGothic",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: this.w - 40 },
            tags: tags
        }).setOrigin(0.5, 0.5);
        this.conclusionBtn.add(this.txt);

        this.conclusionBtn.setSize(390, 155);
        this.conclusionBtn.setInteractive({ useHandCursor: true });
        this.conclusionBtn.input.hitArea.setTo(195, 77.5, 390, 155);

        this.conclusionBtn.on('pointerdown', () => {
            this.clickSound.play();
            this.scene.start("ActiviteConclu")
        })
    }
}